<script setup lang="ts">
import { defineProps, defineModel, computed } from 'vue'

defineProps({
  label: String,
  placeholder: String,
  disabled: Boolean,
  required: Boolean,
  errorMessage: String, // Gérée par le parent
})

const model = defineModel<string | null | undefined>()

const displayValue = computed({
  get: () => (!model.value ? '' : model.value),
  set: (value) => (model.value = value),
})
</script>

<template>
  <label class="form-control w-full">
    <div class="label" v-if="label">
      <span class="label-text font-semibold">
        {{ label }} <span v-if="required" class="text-red-500">*</span>
      </span>
    </div>

    <input
      v-model="displayValue"
      :placeholder="placeholder"
      class="input input-bordered w-full h-[2.5rem] min-h-[2.5rem]"
      :class="{ 'border-red-500': errorMessage }"
      :disabled="disabled"
    />

    <span v-if="errorMessage" class="text-red-500 text-sm">{{ errorMessage }}</span>
  </label>
</template>
